import React from 'react';
import { Link, Routes, Route, Navigate } from 'react-router-dom';
import DailyPlan from './DailyPlan';
import WeeklyPlan from './WeeklyPlan';
import MonthlyPlan from './MonthlyPlan';
import QuarterlyPlan from './QuarterlyPlan';
import YearlyPlan from './YearlyPlan';
import './DailyPlan.module.css';

const Plans = () => {
    return (
        <div className="container">
            <h1 className="my-4">Plans</h1>
            <nav>
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        <Link className="nav-link" to="daily">Daily Plan</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to="weekly">Weekly Plan</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to="monthly">Monthly Plan</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to="quarterly">Quarterly Plan</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to="yearly">Yearly Plan</Link>
                    </li>
                </ul>
            </nav>
            <div className="mt-4">
                <Routes>
                    <Route path="/" element={<Navigate to="daily" replace />} />
                    <Route path="daily" element={<DailyPlan />} />
                    <Route path="weekly" element={<WeeklyPlan />} />
                    <Route path="monthly" element={<MonthlyPlan />} />
                    <Route path="quarterly" element={<QuarterlyPlan />} />
                    <Route path="yearly" element={<YearlyPlan />} />
                </Routes>
            </div>
        </div>
    );
};

export default Plans;
